<template>
<transition name="modal">
<div id="embModal" class="embModal">
  <div class="embModal__main">
    <div class="embModal__main__error">{{ errorMsg }}</div>
    <div class="embModal__main__close" @click="$emit('clickClose')">Close</div>
    <form @submit.prevent="decideText" class="embModal__main__wrap">
      <input
        id="embModalInput"
        class="embModal__main__wrap__input"
        type="text"
        v-model="inputText"
        :placeholder="placeholder" />
      <div class="embModal__main__wrap__check">
        <img v-if="isCanSet === false" src="@/assets/images/custom/custom-input-ng.svg" alt="NG" />
        <img v-if="isCanSet === true" @click="decideText" src="@/assets/images/custom/custom-input-ok.svg" alt="OK" />
      </div>
    </form>
    <ul class="embModal__main__list">
      <li>選択フォント：{{ embData.name }}</li>
      <li v-if="embData.embroidery.description">{{ embData.embroidery.description }}</li>
      <li v-if="embData.embroidery.maxInputs">{{ embData.embroidery.maxInputs }}文字まで入力可能です</li>
    </ul>
  </div>
</div>
</transition>
</template>

<script>
export default {
  props: {
    embData: Object
  },
  data () {
    return {
      errorMsg: '',
      inputText: '',
      isCanSet: false
    }
  },
  watch: {
    inputText: {
      handler () {
        if (this.inputText.length > this.embData.embroidery.maxInputs) {
          this.errorMsg = '入力可能文字数を超えています'
          this.isCanSet = false
        } else if (this.inputText.length < 1) {
          this.errorMsg = ''
          this.isCanSet = false
        } else {
          for (let i = 0; i < this.inputText.length; i++) {
            const result = this.inputText.substr(i, 1).match('[' + this.embData.embroidery.inputRegulation + ']')
            if (result === null) {
              this.errorMsg = '使用できない文字が含まれています'
              this.isCanSet = false
              break
            }
            if (i === this.inputText.length - 1) {
              this.errorMsg = ''
              this.isCanSet = true
            }
          }
        }
      }
    }
  },
  computed: {
    placeholder () {
      if (this.embData.embroidery.maxInputs) {
        return this.embData.embroidery.maxInputs + '文字まで'
      } else {
        return ''
      }
    }
  },
  methods: {
    decideText () {
      if (this.inputText.length === 0) {
        this.errorMsg = '文字を入力して下さい'
        this.isCanSet = false
      } else if (!this.isCanSet) {
        return false
      } else {
        this.$emit('updateEmbData', this.inputText)
      }
    }
  },
  mounted () {
    document.getElementById('embModalInput').focus()
  }
}
</script>

<style lang="scss" scoped>
.embModal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1000;
  transition: all .3s ease;
  background: rgba(#111, 0.8);
  color: $base-white;
  line-height: 1.5;
  &__main {
    width: 75%;
    max-width: 350px;
    margin: 70px auto 0;
    &__error {
      font-weight: bold;
      color: $red;
      height: 20px;
    }
    &__close {
      font-size: 18px;
      text-align: right;
      margin-top: 20px;
    }
    &__wrap {
      margin-top: 5px;
      position: relative;
      &__input {
        width: 100%;
        height: 50px;
        padding: 0 60px 0 10px;
        font-size: 16px;
      }
      &__check {
        position: absolute;
        top: 50%;
        right: 15px;
        margin-top: -15px;
        width: 25px;
        height: 25px;
      }
    }
    &__list {
      font-size: 14px;
      margin-top: 20px;
      list-style: disc;
      padding-left: 20px;
      li {
        padding: 3px 0;
      }
    }
  }
}

@media screen and (min-width: 1000px) {
  .embModal {
    &__main {
      width: 75%;
      max-width: 650px;
      margin: 400px auto 0;
      &__error {
        font-size: 30px;
        height: 45px;
      }
      &__close {
        font-size: 30px;
      }
      &__wrap {
        &__input {
          width: 100%;
          height: 80px;
          padding: 0 60px 0 20px;
          font-size: 28px;
        }
        &__check {
          position: absolute;
          top: 50%;
          right: 15px;
          margin-top: -18px;
          width: 40px;
          height: 40px;
        }
      }
      &__list {
        font-size: 26px;
        margin-top: 30px;
        padding-left: 30px;
        li {
          padding: 5px 0;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/EmbModal.vue